const GEO_TIMEOUT_MS = 3000;

export interface FetchDetectedCountryOptions {
  marketplaceUrl: string;
  fetchImpl?: typeof fetch;
}

export async function fetchDetectedCountry({
  marketplaceUrl,
  fetchImpl,
}: FetchDetectedCountryOptions): Promise<string | null> {
  const doFetch = fetchImpl || fetch;

  const controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
  const timeout = setTimeout(() => controller?.abort(), GEO_TIMEOUT_MS);

  try {
    const response = await doFetch(`${marketplaceUrl}/funnels/funnel/geo-location/`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
      signal: controller?.signal,
    });
    if (!response.ok) return null;

    const body = (await response.json()) as { country?: unknown };
    return normaliseCountry(body?.country);
  } catch {
    return null;
  } finally {
    clearTimeout(timeout);
  }
}

function normaliseCountry(value: unknown): string | null {
  if (typeof value !== 'string') return null;
  const code = value.trim().toUpperCase();
  return /^[A-Z]{2}$/.test(code) ? code : null;
}
